export default function Footer() {
  return (
    <footer className="text-center text-gray-500 text-sm py-8">
      © {new Date().getFullYear()} Jeevitha R · Built with React & Tailwind
    </footer>
  );
}
